module.exports = __webpack_public_path__ + "img/State=5.9e07d4c5.svg";